import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { BrowserUtils } from '@azure/msal-browser';

import { LoginFailedComponent } from '@core/pages/login-failed/login-failed.component';
import { RedirectComponent } from '@core/pages/redirect/redirect.component';
import { UnauthorisedComponent } from '@core/pages/unauthorised/unauthorised.component';

// TODO: change route paths to kebab-case (lower case with dashes) [ future release ]
const routes: Routes = [
  //These routes need to be defined first to allow matching before matching to routes in home module
  {
    path: 'unauthorised',
    component: UnauthorisedComponent,
    title: 'Unauthorised'
  },
  {
    path: 'redirect-app',
    component: RedirectComponent,
    title: 'Redirect'
  },
  {
    path: 'login-failed',
    component: LoginFailedComponent,
    title: 'Login Failed'
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'dashboard'
  },
  {
    path: '',
    loadChildren: () =>
      import('./features/authenticated/authenticated.module').then(
        (m) => m.AuthenticatedModule
      ),
    canActivate: [MsalGuard]
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      initialNavigation:
        !BrowserUtils.isInIframe() && !BrowserUtils.isInPopup()
          ? 'enabledNonBlocking'
          : 'disabled',
      relativeLinkResolution: 'legacy',
      scrollPositionRestoration: 'enabled',
      // Preload all lazy-loaded modules after initial load for faster navigation
      preloadingStrategy: PreloadAllModules
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
